import { jsx as _jsx } from "react/jsx-runtime";
import { $applyNodeReplacement, DecoratorNode } from 'lexical';
export const COMMAND_MENU_QUERY_NODE_TYPE = 'command-menu-query';
export class CommandMenuQueryNode extends DecoratorNode {
    __source;
    __placeholderText;
    __queryStartOffset;
    __showPlaceholder;
    static getType() {
        return COMMAND_MENU_QUERY_NODE_TYPE;
    }
    static clone(node) {
        return new CommandMenuQueryNode(node.__source, node.__placeholderText, node.__queryStartOffset, node.__showPlaceholder, node.__key);
    }
    static importJSON(serializedNode) {
        return $applyNodeReplacement(new CommandMenuQueryNode(serializedNode.source, serializedNode.placeholderText, serializedNode.queryStartOffset, serializedNode.showPlaceholder)).updateFromJSON(serializedNode);
    }
    constructor(__source, __placeholderText, __queryStartOffset, __showPlaceholder, key) {
        super(key);
        this.__source = __source;
        this.__placeholderText = __placeholderText;
        this.__queryStartOffset = __queryStartOffset;
        this.__showPlaceholder = __showPlaceholder;
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            placeholderText: this.__placeholderText,
            queryStartOffset: this.__queryStartOffset,
            showPlaceholder: this.__showPlaceholder,
            source: this.__source,
            type: COMMAND_MENU_QUERY_NODE_TYPE,
        };
    }
    createDOM() {
        const element = document.createElement('span');
        element.style.display = 'inline';
        return element;
    }
    updateDOM() {
        return false;
    }
    getTextContent() {
        return '';
    }
    exportDOM() {
        const element = document.createElement('span');
        element.setAttribute('aria-hidden', 'true');
        return { element };
    }
    static importDOM() {
        return null;
    }
    setShowPlaceholder(showPlaceholder) {
        const writable = this.getWritable();
        writable.__showPlaceholder = showPlaceholder;
    }
    getQueryStartOffset() {
        return this.getLatest().__queryStartOffset;
    }
    getShowPlaceholder() {
        return this.getLatest().__showPlaceholder;
    }
    decorate() {
        return (_jsx("span", { "aria-hidden": true, className: this.__showPlaceholder
                ? 'text-tertiary pointer-events-none select-none whitespace-pre pr-[0.25em]'
                : 'pointer-events-none inline-block w-0 overflow-hidden p-0', contentEditable: false, spellCheck: false, children: this.__showPlaceholder ? this.__placeholderText : '' }));
    }
}
//# sourceMappingURL=CommandMenuQueryNode.js.map